module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//19.jpg?e02163e4b87033e5988bf8af60a9eaf7";